import { SET_USER } from '../actions/userActions';

let initialState = {};

if (localStorage.getItem('currentUser-ARS')) {
    initialState = JSON.parse(localStorage.getItem('currentUser-ARS'));
}

const user = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}

export default user;